/* Auto-generated by scripts/build-consulting-reports.js — do not edit */
const CONSULTING_REPORT_ARTICLES = [
  {
    "slug": "drone-report-202608",
    "type": "gatedPdf",
    "title": {
      "ja": "ドローン業界レポート 2026年8月号：ドローン×農業",
      "en": "Drone Industry Report — August 2026: Drones in Agriculture"
    },
    "description": {
      "ja": "農業用ドローンの市場動向、農業が抱える3つの課題と活用事例、導入時のハードルを1ページにまとめました。全文はPDFをダウンロードしてご覧ください。",
      "en": "A one-page brief on Japan’s agricultural drone market, three farming challenges and drone applications, and barriers to adoption. Download the full PDF (Japanese)."
    },
    "tag": {
      "ja": "ドローン",
      "en": "Drone"
    },
    "publishedAt": "2026-08-31T00:00:00.000Z",
    "imageUrl": "assets/consulting-reports-images/drone-report-202608.svg",
    "pageCount": 1
  },
  {
    "slug": "drone-report-2026",
    "type": "gatedPdf",
    "title": {
      "ja": "ドローン業界レポート 2026",
      "en": "Drone Industry Report 2026"
    },
    "description": {
      "ja": "産業用ドローンの市場・規制・実装を短報形式でまとめたコンサルティングレポートです。全文はダウンロードでご覧ください。",
      "en": "A short consulting brief on industrial drones—market, regulation, and delivery. Download for the full PDF."
    },
    "tag": {
      "ja": "ドローン",
      "en": "Drone"
    },
    "publishedAt": "2026-07-22T00:00:00.000Z",
    "imageUrl": "assets/consulting-reports-images/drone-report-2026.png",
    "pageCount": 2
  }
]
